import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

const { span } = hh(h);
import { Link } from 'react-router';
import styles from './logo.css';

const Logo = (props) => (
    h(Link, {to: '/', className: styles.logo, ...props}, [
        'CODE '.replace(/ /g, '\u00a0'),
        span({className: styles.at}, 'at'),
        ' UNI'.replace(/ /g, '\u00a0')])
);

export default Logo;



/** WEBPACK FOOTER **
 ** ./src/Logo/index.js
 **/